import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ItemPreviewComponent } from "./item-preview.component";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatTabsModule } from "@angular/material/tabs";
import { MatDividerModule } from "@angular/material/divider";
import { ItemPreviewChildrenComponent } from "./children/children.component";
import { ItemPreviewExhibitionsComponent } from "./exhibitions/exhibitions.component";
import { ItemPreviewAuctionsComponent } from "./auctions/auctions.component";
import { ItemPreviewOwnersComponent } from "./owners/owners.component";
import { ItemPreviewPublicationsComponent } from "./publications/publications.component";
import { ItemPreviewRelatedItemsComponent } from "./related-items/related-items.component";
import { SharedPipesModule } from "src/app/shared/pipes/shared-pipes.module";
import { ItemInventoryCodeModule } from "../item-inventory-code/item-inventory-code.module";
import { FlagModule } from "../../flag/flag.module";
import { MatTableModule } from "@angular/material/table";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSortModule } from "@angular/material/sort";
import { LightboxModule } from "../../lightbox/lightbox.module";

@NgModule({
  declarations: [
    ItemPreviewComponent,
    ItemPreviewAuctionsComponent,
    ItemPreviewChildrenComponent,
    ItemPreviewExhibitionsComponent,
    ItemPreviewOwnersComponent,
    ItemPreviewPublicationsComponent,
    ItemPreviewRelatedItemsComponent,
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatTabsModule,
    MatDividerModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    SharedPipesModule,
    ItemInventoryCodeModule,
    FlagModule,
    LightboxModule,
  ],
  exports: [ItemPreviewComponent],
})
export class ItemPreviewModule {}
